import Splide from '@splidejs/splide';

// Categories Grid
(() => {
  const categoryGrid = document.querySelector('.category-section-2');
  if (!categoryGrid) return;

  categoryGrid.querySelectorAll('.quicklinks > ul > li > a').forEach((item) => {
    item.nextElementSibling.append(item.cloneNode(true));
  });
})();

(() => {
  const categorySource = document.querySelector('.category-section-2');
  if (!categorySource) return;

  const slider = document.createElement('div');
  slider.classList.add('category-section-2__slider', 'splide');
  categorySource.appendChild(slider);
  const sliderTrack = document.createElement('div');
  sliderTrack.classList.add('splide__track');
  slider.appendChild(sliderTrack);
  const sliderList = document.createElement('div');
  sliderList.classList.add('splide__list');
  sliderTrack.appendChild(sliderList);

  const categories = categorySource.querySelectorAll('.hasSubmenus > li');
  categories.forEach((category) => {
    const sliderSlide = document.createElement('div');
    sliderSlide.classList.add('splide__slide');
    sliderSlide.innerHTML = category.innerHTML;
    sliderList.appendChild(sliderSlide);
  });

  categorySource.querySelector('.quicklinks').insertAdjacentElement('beforeend', slider);

  const cardAmount = slider.querySelectorAll('.splide__slide').length;
  const splide = new Splide(slider, {
    type: 'slider',
    perPage: 4,
    perMove: 1,
    height: 491,
    gap: 10,
    pagination: cardAmount > 4,
    arrows: false,
    drag: cardAmount > 4,
    breakpoints: {
      1200: {
        perPage: 3,
        drag: cardAmount > 3,
        arrows: cardAmount > 3,
      },
      991: {
        perPage: 2,
        drag: cardAmount > 2,
        arrows: cardAmount > 2,
      },
      600: {
        perPage: 1,
        drag: cardAmount > 1,
        arrows: cardAmount > 1,
      },
    },
  });
  splide.mount();
})();
